import { Singleton } from '../js/Singleton';
export function alertQueryErrorBody(){
    var language = new Singleton();
    const body={
        type: "ModalError",
        title: language.getText("GUIErrorMessagetitle"),
        message: language.getText("error-8000"),
        button: language.getText("GUIErrorMessageclose"),
        secondButtonFtn: () => { },
        buttonFun: () => {  }
    }
    return body;
  }


// WEBPACK FOOTER //
// ./src/js/alertQueryErrorBody.js